import { Check, X, Download, Flag, Trash2, Shield, ShieldOff } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Badge } from '@/components/ui/badge'
import { Separator } from '@/components/ui/separator'

interface BulkActionsBarProps {
  selectedCount: number
  onApproveAll: () => void
  onRejectAll: () => void
  onExportSelected: () => void
  onFlagAll: () => void
  onWhitelist: () => void
  onBlacklist: () => void
  onClearSelection: () => void
  disabled?: boolean
}

export function BulkActionsBar({
  selectedCount,
  onApproveAll,
  onRejectAll,
  onExportSelected,
  onFlagAll,
  onWhitelist,
  onBlacklist,
  onClearSelection,
  disabled = false
}: BulkActionsBarProps) {
  if (selectedCount === 0) return null
  
  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50">
      <div className="bg-card border border-border rounded-lg shadow-lg p-4 flex items-center gap-4">
        <div className="flex items-center gap-2">
          <Badge variant="secondary" className="bg-primary/10 text-primary">
            {selectedCount} selected
          </Badge>
          
          <Button
            variant="ghost"
            size="sm"
            onClick={onClearSelection}
            className="h-6 px-2 text-xs"
          >
            Clear
          </Button>
        </div>
        
        <Separator orientation="vertical" className="h-6" />
        
        <div className="flex items-center gap-2">
          <Button
            size="sm"
            variant="outline"
            onClick={onApproveAll}
            disabled={disabled}
            className="text-green-600 hover:bg-green-50 border-green-200"
          >
            <Check className="h-4 w-4 mr-2" />
            Approve All
          </Button>
          
          <Button
            size="sm"
            variant="outline"
            onClick={onRejectAll}
            disabled={disabled}
            className="text-red-600 hover:bg-red-50 border-red-200"
          >
            <X className="h-4 w-4 mr-2" />
            Reject All
          </Button>
          
          <Button
            size="sm"
            variant="outline"
            onClick={onFlagAll}
            disabled={disabled}
          >
            <Flag className="h-4 w-4 mr-2" />
            Flag for Review
          </Button>
        </div>
        
        <Separator orientation="vertical" className="h-6" />
        
        <div className="flex items-center gap-2">
          <Button
            size="sm"
            variant="outline"
            onClick={onWhitelist}
            disabled={disabled}
            className="text-green-600"
          >
            <Shield className="h-4 w-4 mr-2" />
            Whitelist
          </Button>
          
          <Button
            size="sm"
            variant="outline"
            onClick={onBlacklist}
            disabled={disabled}
            className="text-red-600"
          >
            <ShieldOff className="h-4 w-4 mr-2" />
            Blacklist
          </Button>
          
          <Button
            size="sm"
            variant="outline"
            onClick={onExportSelected}
            disabled={disabled}
          >
            <Download className="h-4 w-4 mr-2" />
            Export
          </Button>
        </div>
      </div>
    </div>
  )
}